import React from "react";
import {
  AdminClient,
  Login,
  ReportPage,
  AdminPage,
  HelpPage,
  TermsOfService,
  NotFundPage,
  PrivacyPolicy,
  PresentationPage,
  AccountMiddleware,
  ChangePasswordMiddleware,
  RevokeMiddleware,
  LaunchMiddleware,
  DisconnectMiddleware,
  UserListPage,
  CustomerListPage,
  ProjectListPage,
  ProjectTemplateListPage,
  CustomerListByProject,
  DashboardClient,
  DashboardPage,
  ContactListPage,
  CustomerDetailPage,
  FileManagerPage,
  FileManagerClient,
  InvoicedVsTimeReport,
} from "../../pages";
import { Navigate } from "react-router-dom";
import { ROLES } from "../../utils/roles";

const routes = {
  initial: "/",
  about: "/about",
  account: "/accounts/:idUser/:realmId",
  revoke: "/revoke",
  disconnect: "/disconnect/:idUser",
  launch: "/launch",
  accountPassword: "/account-auth/:idClient",
  login: "/login",
  admin: "/admin",
  userList: "/users/:idClient",
  adminClient: "/admin/:idClient",
  contacts: "/contacts/:idClient",
  dashboard: "/dashboard/:idClient",
  customerListPage: "/customer/:idClient",
  customerDetailPage: "/customer-detail/:idClient/:idCustomer",
  fileManagerPage: "/files/:idClient",
  fileManagerClient: "/client-files/:idClient/:idCustomer",
  projectListPage: "/project/:idClient",
  projectTemplateListPage: "/project-template/:idClient",
  customerByProject: "/customer-project/:idClient/:idProject",
  help: "/help",
  report: "/report",
  invoicedVsTimeReport: "/reports/invoiced-vs-time/:idClient",
  terms: "/terms",
  privacy: "/privacy",
  notFound: "/*",
};

export const AppPages = [
  {
    path: routes.initial,
    protected: false,
    component: <Navigate to={routes.login} replace />,
  },
  { path: routes.login, protected: false, component: <Login /> },
  {
    path: routes.account,
    isMiddleware: true,
    component: <AccountMiddleware />,
  },
  {
    path: routes.launch,
    protected: true,
    isProtectedMiddleware: true,
    component: <LaunchMiddleware />,
    permissions: [],
  },
  {
    path: routes.launch,
    isMiddleware: true,
    component: <LaunchMiddleware />,
  },
  {
    path: routes.revoke,
    protected: true,
    isProtectedMiddleware: true,
    component: <RevokeMiddleware />,
    permissions: [],
  },
  {
    path: routes.revoke,
    isMiddleware: true,
    component: <RevokeMiddleware />,
  },
  {
    path: routes.disconnect,
    protected: true,
    isProtectedMiddleware: true,
    component: <DisconnectMiddleware />,
    permissions: [],
  },
  {
    path: routes.disconnect,
    isMiddleware: true,
    component: <DisconnectMiddleware />,
    permissions: [],
  },

  {
    path: routes.accountPassword,
    isMiddleware: true,
    component: <ChangePasswordMiddleware />,
  },

  {
    path: routes.userList,
    protected: true,
    component: <UserListPage />,
    permissions: [],
  },
  { path: routes.about, protected: false, component: <PresentationPage /> },
  { path: routes.terms, isMiddleware: true, component: <TermsOfService /> },
  { path: routes.privacy, isMiddleware: true, component: <PrivacyPolicy /> },
  {
    path: routes.report,
    protected: true,
    component: <ReportPage />,
    permissions: [],
  },
  {
    path: routes.admin,
    protected: true,
    component: <AdminPage />,
    permissions: [],
  },

  {
    path: routes.adminClient,
    protected: true,
    component: <AdminClient />,
    permissions: [],
  },

  {
    path: routes.customerListPage,
    protected: true,
    component: <CustomerListPage />,
    permissions: [ROLES.USER],
  },
  {
    path: routes.customerDetailPage,
    protected: true,
    component: <CustomerDetailPage />,
    permissions: [ROLES.USER],
  },
  {
    path: routes.customerByProject,
    protected: true,
    component: <CustomerListByProject />,
    permissions: [ROLES.USER],
  },
  {
    path: routes.projectListPage,
    protected: true,
    component: <ProjectListPage />,
    permissions: [ROLES.USER],
  },
  {
    path: routes.projectTemplateListPage,
    protected: true,
    component: <ProjectTemplateListPage />,
    permissions: [ROLES.USER],
  },
  {
    path: routes.contacts,
    protected: true,
    component: <ContactListPage />,
    permissions: [ROLES.USER],
  },
  {
    path: routes.dashboard,
    protected: true,
    component: <DashboardClient />,
    permissions: [ROLES.USER],
  },
  {
    path: routes.fileManagerPage,
    protected: true,
    component: <FileManagerPage />,
    permissions: [ROLES.USER, ROLES.CLIENT],
  },
  {
    path: routes.fileManagerClient,
    protected: true,
    component: <FileManagerClient />,
    permissions: [ROLES.USER, ROLES.CLIENT],
  },
  {
    path: routes.dashboard,
    protected: true,
    component: <DashboardPage />,
    permissions: [ROLES.USER],
  },

  {
    path: routes.help,
    protected: true,
    component: <HelpPage />,
    permissions: [ROLES.USER, ROLES.CLIENT],
  },
  {
    path: routes.report,
    protected: true,
    component: <ReportPage />,
    permissions: [],
  },
  {
    path: routes.invoicedVsTimeReport,
    protected: true,
    component: <InvoicedVsTimeReport />,
    permissions: [ROLES.USER, ROLES.DEMO],
  },
  {
    path: routes.notFound,
    protected: true,
    component: <NotFundPage />,
    permissions: [ROLES.USER, ROLES.CLIENT, ROLES.DEMO],
  },
  { path: routes.notFound, protected: false, component: <NotFundPage /> },
];
